import { BusinessLocation } from '@models/validation';
import { BillingAddressAutofillType } from '@pages/BindQuote/BillingCard';

export function getBillingAddressAutoFillValues({
  businessAddress,
  addressType,
  namedInsuredItem,
}: {
  businessAddress: BusinessLocation | null;
  addressType: BillingAddressAutofillType;
  namedInsuredItem: any;
}) {
  const existingNamedInsuredValues = {
    careOf: namedInsuredItem.attributeTypes.CustomerContact?.attribute?.value,
    email: namedInsuredItem.attributeTypes.CustomerEmail?.attribute?.value,
    phone: namedInsuredItem.attributeTypes.CustomerPhone?.attribute?.value,
    street: namedInsuredItem.attributeTypes.MailingStreet?.attribute?.value,
    street2: namedInsuredItem.attributeTypes.MailingStreet2?.attribute?.value,
    city: namedInsuredItem.attributeTypes.MailingCity?.attribute?.value,
    state: namedInsuredItem.attributeTypes.MailingState?.attribute?.value,
    zip: namedInsuredItem.attributeTypes.MailingZip?.attribute?.value,
  } as Record<string, string | undefined>;

  if (addressType === 'Business') {
    return {
      street: { value: businessAddress?.street1 || '' },
      street2: { value: businessAddress?.street2 || '' },
      city: { value: businessAddress?.city || '' },
      state: { value: businessAddress?.state || '' },
      zip: { value: businessAddress?.zipCode || '' },
      phone: { value: existingNamedInsuredValues.phone || '' },
      primaryContact: { value: existingNamedInsuredValues.careOf || '' },
      emailAddress: { value: existingNamedInsuredValues.email || '' },
    };
  }

  if (addressType === 'Mailing') {
    return {
      street: { value: existingNamedInsuredValues.street || '' },
      street2: { value: existingNamedInsuredValues.street2 || '' },
      city: { value: existingNamedInsuredValues.city || '' },
      state: { value: existingNamedInsuredValues.state || '' },
      zip: { value: existingNamedInsuredValues.zip || '' },
      phone: { value: existingNamedInsuredValues.phone || '' },
      primaryContact: { value: existingNamedInsuredValues.careOf || '' },
      emailAddress: { value: existingNamedInsuredValues.email || '' },
    };
  }

  return {};
}
